import React from 'react'
import { Text, Box } from "grommet"

const LayoutListSeparator = ({ itemText }) => {

    return (
        <Box
            background="brand"
            pad="3px"
            tag="li"
            gap="xsmall"
            margin="none"
            alignContent="center"
            direction='row'
        >
            <Text margin={{left: "xsmall"}} size="xsmall" weight="bold" color="light-1">{itemText}</Text>
        </Box >
    )
}

export default LayoutListSeparator
